const initialState = {
	allBlogs: [],
	loading: false,
};
const blogReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'ADD_BLOG_REQUEST':
			return {
				...state,
				loading: true,
			};
		case 'ADD_BLOG_SUCCESS':
			return {
				...state,
				loading: false,
			};
		case 'GET_ALL_BLOGS':
			return {
				...state,
				allBlogs: action.payload,
			};

		case 'UPDATE_BLOG':
			return {
				...state,
			};
		case 'DELETE_BLOG':
			return {
				...state,
			};

		default:
			return state;
	}
};

export default blogReducer;
